<template>
  <el-row class="egl-elm egl-detail setting clearfix">
    <!--<el-form-item :label="$locale('setting.cinema.ticket.boxend')+' *'">
      <el-input :placeholder="$locale('setting.cinema.p.minutes.30')" v-model="form.releaseAfterMin" :disabled="!editable"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.ticket.onlineend')+' *'">
      <el-input :placeholder="$locale('setting.cinema.p.minutes.10')" v-model="form.releaseBeforeMin" :disabled="!editable"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.ticket.boxstart')+' *'">
      <el-input :placeholder="$locale('setting.cinema.p.days.2')" v-model="form.showDaysPos" :disabled="!editable"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.ticket.onlinestart')+' *'">
      <el-input :placeholder="$locale('setting.cinema.p.days.2')" v-model="form.showDaysWeb" :disabled="!editable"></el-input>
    </el-form-item>-->
    <el-col :span="24">
      <el-form-item :label="$locale('setting.cinema.ticket.closehour')" prop="cinemaSetting.dailyCloseTime" :rules="formRules.dailyCloseTime">
        <el-input :placeholder="$locale('setting.cinema.p.hours.00')" v-model.number="detailObj.cinemaSetting.dailyCloseTime" :disabled="!editable" maxlength="2"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="4">
      <el-form-item :label="$locale('schedule.freeSeat')" prop="cinemaSetting.freeSeat">
        <el-select :placeholder="$locale('form.plsSelect')" v-model.number="detailObj.cinemaSetting.freeSeat" :disabled="!editable">
          <el-option
              v-for="_fs in freeSeatOptions"
              :key="_fs.id"
              :value="_fs.value"
              :label="_fs.name"
            ></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <!--<el-form-item :label="$locale('setting.cinema.ticket.boxmax')+' *'">
      <el-input placeholder="例) 10" v-model="form.seatMaxPos" :disabled="!editable"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.ticket.onlinemax')+' *'">
      <el-input placeholder="例) 10" v-model="form.seatMaxWeb" :disabled="!editable"></el-input>
    </el-form-item>-->
  </el-row>
</template>

<script>

export default {
  name: "cinemaTicketSetting",
  props: {
    detailObj: Object,
  },
  data() {
    return {
      editable: true,
      action: "create",
      formRules: {
        dailyCloseTime: [
          {
            required: true,
            message: this.$locale("setting.cinema.plsEnterClosingTime"),
            trigger: "blur",
          },
          {
            type: "number",
            message: this.$locale("form.mustFillInNum"),
            trigger: "blur",
          },
          {
            validator: this.closingTimeValidator,
            trigger: "blur",
          }
        ]
      },
      freeSeatOptions: [
        {
          id: "true",
          value: true,
          name: this.$locale("global.yes"),
        },
        {
          id: "false",
          value: false,
          name: this.$locale("global.no"),
        },
      ],
    };
  },
  methods: {
    closingTimeValidator(_, value, callback) {
      if (value >= 0 && value < 36) {
        callback();
      } else {
        callback(new Error(this.$locale("setting.cinema.closingTimeMax")));
      }
    }
  },
};
</script>
